import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

let firebaseApp;
SetupFirebase();

function SetupFirebase() {
  const firebaseConfig = {
    apiKey: "AIzaSyB9w_PhdRjGWEfz4ggaMTInPAXZdBNrcAo",
    authDomain: "bliss-water-technology.firebaseapp.com",
    projectId: "bliss-water-technology",
    storageBucket: "bliss-water-technology.firebasestorage.app",
    messagingSenderId: "556981369465",
    appId: "1:556981369465:web:72f02a57db893df10972a8",
    measurementId: "G-P82TBVQRT4",
  };
  firebaseApp = firebase.initializeApp(firebaseConfig);
}

export default firebaseApp;
